export default {
  SET_TOKEN(state, value) {
    state.token = value;
  },
  SET_ROLE(state, value) {
    state.role = value;
  },
  SET_STATUS(state, value) {
    state.status = value;
  },
  SET_FIRST_SIGNIN(state, value) {
    state.first_signin = value;
  },
  SET_SUBSCRIPTION_PLAN(state, value) {
    state.subscriptionPlan = value;
  },
  SET_USER(state, value) {
    let user = value;
    if (
      !user.picture ||
      user.picture === `${process.env.VUE_APP_ADBOX_APP_FRONT_URL}/avatar_.png`
    )
      user.picture = `${process.env.VUE_APP_ADBOX_APP_FRONT_URL}/avatar.png`;
    state.user = user;
    state.collectionMonths = value.collectionMonths
      ? value.collectionMonths
      : null;
  },
  SET_SUBSCRIPTION(state, value) {
    state.subscription = value.response[0];
  },
  SET_TRANSACTION(state, value) {
    state.transaction = value.response[0];
  },
  SET_MEMBERSHIPS(state, value) {
    state.plans = value.map((plan) => {
      plan.features = JSON.parse(plan.features);
      plan.extras,
        (plan.paddle = {
          id: plan.paddle_plan_id,
          vendor: 26610,
        });
      return plan;
    });
  },
  SET_VERBAL_HOOKS(state, value) {
    state.verbalHooks = value;
  },
  SET_UGC_CREATORS(state, value) {
    state.ugcCreators = value;
  },
  SET_SELECTED_UGC_CREATOR(state, value) {
    state.selectedUgcCreator = value;
  },
  SET_CASES_STUDY(state, value) {
    state.cases = value.case_studies;
    state.freeCases = value.free_case_studies;
  },
  SET_DIRECTORY(state, value) {
    state.directory = value;
  },
  SET_TIKTOKS(state, value) {
    if (value) {
      const areThereFavorites = state.favoritesTiktoks
        ? state.favoritesTiktoks.length
        : null;
      const normalizeTiktoks = value.tiktoks.map((tiktok) => {
        // Match with favorites
        let isExist = false;
        if (areThereFavorites) {
          isExist = state.favoritesTiktoks.some(
            (favoriteTiktok) => tiktok.id === favoriteTiktok.tiktok_id
          )
            ? state.favoritesTiktoks.find(
                (favoriteTiktok) => tiktok.id === favoriteTiktok.tiktok_id
              ).id
            : false;
        }
        tiktok.isFavorite = isExist;
        return tiktok;
      });

      state.tiktoks = normalizeTiktoks;
    } else {
      state.tiktoks = null;
    }
  },
  SET_TOP_BRANDS(state, value) {
    if (value && value.top_brands) {
      const areThereFavorites = state.favoritesTopBrands
        ? state.favoritesTopBrands.length
        : null;
      const normalizeBrands = value.top_brands.map((topBrand) => {
        // Match with favorites
        let isExist = false;
        if (areThereFavorites) {
          isExist = state.favoritesTopBrands.some(
            (favoriteTopBrand) => topBrand.id === favoriteTopBrand.brand_id
          );
        }
        topBrand.isFavorite = isExist;
        return topBrand;
      });
      state.topBrands = normalizeBrands;
    } else {
      state.topBrands = null;
    }
  },
  SET_TIKTOK_TITLES_SUBTITLES(state, value) {
    state.tiktokTitleSubtitle = value;
  },
  SET_HOME_TITLES_SUBTITLES(state, value) {
    state.homeTitleSubtitle = value;
  },
  SET_FB_IG_TITLES_SUBTITLES(state, value) {
    state.fbIgTitleSubtitle = value;
  },
  SET_DISCOVER_SUBTITLES(state, value) {
    state.discoverSubtitle = value;
  },
  SET_TOP_BRANDS_TITLES_SUBTITLES(state, value) {
    state.topBrandTitleSubtitle = value;
  },
  SET_HOOKS_TITLES_SUBTITLES(state, value) {
    state.hooksTitleSubtitle = value;
  },
  SET_CALENDAR_TITLES_SUBTITLES(state, value) {
    state.calendarTitleSubtitle = value;
  },
  SET_ADS_TEST_FIRST_TITLES_SUBTITLES(state, value) {
    state.adsToTestFirstTitleSubtitle = value;
  },
  SET_PSYCOLOGY_TITLES_SUBTITLES(state, value) {
    state.psycologyTitleSubtitle = value;
  },
  SET_CASE_STUDIES_TITLES_SUBTITLES(state, value) {
    state.caseStudiesTitleSubtitle = value;
  },
  SET_DEALS_TOOLS_TITLES_SUBTITLES(state, value) {
    state.dealsToolsTitleSubtitle = value;
  },
  SET_OUR_PROCESS_TITLES_SUBTITLES(state, value) {
    state.ourProcessTitleSubtitle = value;
  },
  SET_UGC_CREATORS_TITLES_SUBTITLES(state, value) {
    state.ugcCreatorsTitleSubtitle = value;
  },
  SET_ADVERTISEMENTS(state, value) {
    if (value) {
      const areThereFavorites = state.favoritesAds
        ? state.favoritesAds.length
        : null;
      const normalizeAds = value.map((ad) => {
        // Match with favorites
        let isExist = false;
        if (areThereFavorites) {
          isExist = state.favoritesAds.some(
            (favoriteAd) => ad.id === favoriteAd.id
          );
        }
        ad.isFavorite = isExist;
        return ad;
      });
      state.advertisements = normalizeAds;
    } else {
      state.advertisements = null;
    }
  },
  SET_PREMIUM_ADS(state, value) {
    state.premium_ads = value;
  },
  SET_ADS_TOTAL(state, value) {
    state.ads_total = value;
  },
  SET_TOTAL_ADVERTISEMENTS(state, value) {
    state.totalAdvertisements = value;
  },
  SET_TOTAL_DISCOVER(state, value) {
    state.totalDiscover = value;
  },
  SET_TOTAL_USERS(state, value) {
    state.totalUsers = value;
  },
  SET_TOTAL_TOP_BRANDS(state, value) {
    state.totalTopBrands = value;
  },
  SET_TOTAL_CASES(state, value) {
    state.totalCases = value;
  },
  SET_TOTAL_TIKTOKS(state, value) {
    state.totalTiktoks = value;
  },
  SET_TOTAL_VERBAL_HOOKS(state, value) {
    state.totalVerbalHooks = value;
  },
  SET_TOTAL_UGC_CREATORS(state, value) {
    state.totalUgcCreators = value;
  },
  SET_CURRENT_AD(state, value) {
    state.currentAd = value;
  },
  SET_PREV_ID_AD(state, value) {
    state.prevIdAd = value;
  },
  SET_NEXT_ID_AD(state, value) {
    state.nextIdAd = value;
  },
  SET_PAGE(state, value) {
    state.page = value;
    state.nextPage = value + 1;
  },
  SET_PAGE_Tiktoks(state, value) {
    state.pageTiktoks = value;
    state.nextPage = value + 1;
  },
  SET_PAGE_Cases(state, value) {
    state.pageCases = value;
    state.nextPage = value + 1;
  },
  SET_PAGE_TopBrands(state, value) {
    state.pageTopBrands = value;
    state.nextPage = value + 1;
  },
  SET_PAGE_VERBAL_HOOKS(state, value) {
    state.pageVerbalHooks = value;
    state.nextPage = value + 1;
  },
  SET_PAGE_UgcCreators(state, value) {
    state.pageUgcCreators = value;
    state.nextPage = value + 1;
  },
  NEXT_PAGE(state) {
    state.page = state.page + 1;
    state.nextPage = state.page + 1;
  },
  SET_FILTERS_PROPERTY(state, { key, value }) {
    state.filters[key] = value;
  },
  SET_FILTERS_PROPERTY_TOP_BRANDS(state, { key, value }) {
    state.filters_topBrands[key] = value;
  },
  SET_FILTERS_PROPERTY_UGC_CREATORS(state, { key, value }) {
    state.filters_ugcCreators[key] = value;
  },
  SET_FILTERS_PROPERTY_TIKTOKS(state, { key, value }) {
    state.filters_tiktoks[key] = value;
  },
  SET_FILTERS(state, value) {
    state.filters = value;
  },
  CLEAN_FILTERS_TOP_BRANDS(state) {
    state.filters_topBrands = {
      search: "",
      industry: "",
      country: "",
    };
  },
  CLEAN_FILTERS_UGC_CREATORS(state) {
    state.filters_ugcCreators = {
      search: "",
      industry: "",
      country: "",
      gender: "",
    };
  },
  CLEAN_FILTERS_TIKTOKS(state) {
    state.filters_tiktoks = {
      search: "",
      industry: "",
      month: null,
    };
  },
  CLEAN_FILTERS(state) {
    state.filters = {
      search: "",
      industry: "",
      type: "",
      objective: "",
      format: "",
      exit_analysis: "",
      month: "",
    };
  },
  SET_ADS_TEST_FIRST(state, value) {
    if (value < 0) {
      state.selectedAdTest = null;
    } else {
      state.selectedAdTest = { ...state.adsTestFirst[value], index: value };
    }
  },
  SET_HOOKS(state, value) {
    if (value < 0) {
      state.selectedHook = null;
    } else {
      state.selectedHook = { ...state.hooks[value], index: value };
    }
  },

  SET_FAVORITES_ADS(state, value) {
    value.forEach((ad) => {
      ad.isFavorite = true;
    });
    state.favoritesAds = value;
  },
  SET_FAVORITES_TOP_BRANDS(state, value) {
    value.forEach((ad) => {
      ad.isFavorite = ad.id;
    });
    state.favoritesTopBrands = value;
  },
  SET_FAVORITES_TIKTOKS(state, value) {
    value = value.map((ad) => {
      ad.isFavorite = ad.id;
      return ad;
    });
    state.favoritesTiktoks = value;
  },
  ADD_AD_TO_FAVORITES(state, value) {
    let ad = value;
    ad.isFavorite = true;

    const index = state.advertisements.findIndex((item) => item.id == ad.id);
    state.advertisements.splice(index, 1, ad);
    state.favoritesAds.unshift(ad);
  },
  REMOVE_AD_TO_FAVORITES(state, value) {
    state.advertisements = state.advertisements.map((item) => {
      if (item.id == value) {
        item.isFavorite = false;
      }
      return item;
    });
    const index = state.favoritesAds.findIndex((item) => item.id == value);
    state.favoritesAds.splice(index, 1);
  },
  ADD_TIKTOK_TO_FAVORITES(state, { value, favorite_id }) {
    let tiktok = value;
    tiktok.isFavorite = favorite_id;

    const index = state.tiktoks.findIndex((item) => item.id == tiktok.id);
    state.tiktoks.splice(index, 1, tiktok);
    state.favoritesTiktoks.unshift(tiktok);
  },
  REMOVE_TIKTOK_TO_FAVORITES(state, value) {
    state.tiktoks = state.tiktoks.map((item) => {
      if (item.id == value) {
        item.isFavorite = false;
      }
      return item;
    });
    const index = state.favoritesTiktoks.findIndex((item) => item.id == value);
    state.favoritesTiktoks.splice(index, 1);
  },
  ADD_BRAND_TO_FAVORITES(state, { value, favorite_id }) {
    let brand = value;
    brand.isFavorite = favorite_id;

    const index = state.topBrands.findIndex((item) => item.id == brand.id);
    state.topBrands.splice(index, 1, brand);
    state.favoritesTopBrands.unshift(brand);
  },
  REMOVE_BRAND_TO_FAVORITES(state, value) {
    state.advertisements = state.topBrands.map((item) => {
      if (item.id == value) {
        item.isFavorite = false;
      }
      return item;
    });
    const index = state.favoritesTopBrands.findIndex(
      (item) => item.id == value
    );
    state.favoritesTopBrands.splice(index, 1);
  },
  SET_OURPLANS_ACTIVE(state, value) {
    state.ourPlansIsActive = value;
  },
};
